import { RealityCheckPeriod } from '../responsible-gaming-config.model';

export function mapRealityCheckPeriodSecondsToLabel(seconds: number) {
  return realityCheckPeriodToLabel[seconds];
}

const realityCheckPeriodToLabel: Record<RealityCheckPeriod, string> = {
  [RealityCheckPeriod.NONE]: 'None',
  [RealityCheckPeriod.ONE_MIN]: '1m',
  [RealityCheckPeriod.FIVE_MINS]: '5m',
  [RealityCheckPeriod.TEN_MINS]: '10m',
  [RealityCheckPeriod.FIFTEEN_MINS]: '15m',
  [RealityCheckPeriod.TWENTY_MINS]: '20m',
  [RealityCheckPeriod.THIRTY_MINS]: '30m',
  [RealityCheckPeriod.FORTY_MINS]: '40m',
  [RealityCheckPeriod.SIXTY_MINS]: '60m',
};

export function secondsToRealityCheckPeriodEnumKey(seconds: number | undefined): string {
  if (!seconds) {
    return RealityCheckPeriod[0 as RealityCheckPeriod];
  }
  return RealityCheckPeriod[seconds as RealityCheckPeriod];
}
